import { render, staticRenderFns } from "./LoginRegist.vue?vue&type=template&id=14f77aa0&"
import script from "./LoginRegist.vue?vue&type=script&lang=js&"
export * from "./LoginRegist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports